import React from "react"

function FeaturingSpeakerCard({ name, position, image }) {
  return (
    <div className="flex items-center justify-center p-4 box-content space-x-4">
      <img
        className="w-24 h-24 rounded-full object-cover"
        src={image}
        alt="Speaker"
      />
      <div>
        <p className="text-gray-500 text-sm font-bold lg:text-base">
          {name || "Name"}
        </p>
        <p className="text-gray-500 text-xs lg:text-sm">{position || ""}</p>
      </div>
    </div>
  )
}

export default FeaturingSpeakerCard
